// Optimistic cart price updates.
// When the shopper clicks +/- on a cart line, the theme already updates the
// number instantly but waits ~1s for the server before the PRICE changes.
// This updates the line price (+ compare), the estimated total, and the free
// shipping progress bar in the browser immediately, using per-unit prices stored
// on each row (data-unit-price / data-unit-compare, in cents). The Section
// Rendering API morph reconciles the real values when the server responds — so
// the worst case is a brief self-correction, never a wrong final value.
(function () {
  if (window.__iraziaOptimisticPriceBound) return;
  window.__iraziaOptimisticPriceBound = true;

  const FORMAT = window.__iraziaMoneyFormat || '${{amount}}';
  const FORMAT_CURRENCY = window.__iraziaMoneyWithCurrencyFormat || FORMAT;

  function formatMoney(cents, format) {
    format = format || FORMAT;
    cents = Math.round(Number(cents) || 0);
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = match ? match[1] : 'amount';
    function fmt(precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      const num = (cents / 100).toFixed(precision);
      const parts = num.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    let value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(0); break;
      case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = fmt(2, "'", '.'); break;
      default: value = fmt(2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Mirror the bar's Liquid: replace [remaining] and turn **bold** into <strong>.
  function fsbHtml(template, remainingMoney) {
    return (template || '')
      .split('**')
      .map((part, i) => {
        const safe = escapeHtml(part).replace('[remaining]', remainingMoney);
        return i % 2 === 1 ? '<strong>' + safe + '</strong>' : safe;
      })
      .join('');
  }

  function rowQty(row) {
    const input = row.querySelector('input[type="number"]');
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  function updateLine(row, qty) {
    const unit = parseInt(row.dataset.unitPrice, 10);
    if (isNaN(unit)) return;
    const compare = parseInt(row.dataset.unitCompare, 10) || 0;
    const onSale = compare > unit;
    const lineTotal = unit * qty;

    const current = row.querySelector('.cart-items__price-current');
    if (current) {
      current.textContent = lineTotal === 0 ? 'FREE' : formatMoney(lineTotal);
      current.classList.toggle('cart-items__price-current--sale', onSale);
    }
    const compareEl = row.querySelector('.compare-at-price');
    if (compareEl && onSale) compareEl.textContent = formatMoney(compare * qty);
  }

  function cartTotal(drawer) {
    let total = 0;
    drawer.querySelectorAll('.cart-items__table-row').forEach((row) => {
      const unit = parseInt(row.dataset.unitPrice, 10);
      if (!isNaN(unit)) total += unit * rowQty(row);
    });
    return total;
  }

  function updateTotal(drawer, total) {
    const totalEl = drawer.querySelector('.cart-totals__total-value');
    if (totalEl) {
      const formatted = formatMoney(total, FORMAT_CURRENCY);
      totalEl.textContent = formatted;
      totalEl.setAttribute('value', formatted);
    }
  }

  function updateFreeShipping(drawer, total) {
    const bar = drawer.querySelector('.cart-fsb');
    if (!bar) return;
    const threshold = parseInt(bar.dataset.fsbThreshold, 10);
    if (!threshold) return;
    const remaining = threshold - total;
    const pct = Math.min(100, Math.max(0, (total / threshold) * 100));
    const fill = bar.querySelector('.cart-fsb__fill');
    if (fill) fill.style.width = pct + '%';
    const textEl = bar.querySelector('.cart-fsb__text');
    if (textEl) {
      textEl.innerHTML =
        remaining > 0
          ? fsbHtml(bar.dataset.fsbProgressText, formatMoney(remaining))
          : fsbHtml(bar.dataset.fsbSuccessText, '');
    }
  }

  document.addEventListener('quantity-selector:update', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const drawer = target.closest('#cart-drawer');
    if (!drawer) return; // only the cart drawer
    const row = target.closest('.cart-items__table-row');
    if (!row) return;
    const qty = event.detail && typeof event.detail.quantity === 'number' ? event.detail.quantity : rowQty(row);
    updateLine(row, qty);
    const total = cartTotal(drawer);
    updateTotal(drawer, total);
    updateFreeShipping(drawer, total);
  });
})();
